var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    directives: [{
      name: "resize",
      rawName: "v-resize",
      value: _vm.onResize,
      expression: "onResize"
    }],
    key: 'signform' + _vm.pages.length,
    style: "height: calc(100vh".concat(!_vm.isHeadless ? ' - 64px' : '', "); overflow-y: hidden; overflow-x: hidden;")
  }, [_c('v-row', {
    style: "height: calc(100%".concat(_vm.isHorizontalPageList ? ' - 100px' : '', "); overflow-y: hidden;"),
    attrs: {
      "no-gutters": ""
    }
  }, [_vm.isVerticalPageList ? _c('v-col', {
    staticStyle: {
      "height": "100%",
      "z-index": "5",
      "background-color": "#f5f5f5"
    },
    attrs: {
      "cols": "1",
      "xs": "0",
      "sm": "2",
      "md": "1",
      "lg": "1"
    }
  }, [_c('v-sheet', {
    staticStyle: {
      "height": "100%",
      "width": "100%",
      "overflow-y": "auto",
      "overflow-x": "hidden"
    },
    attrs: {
      "rounded": "tr-lg br-lg",
      "elevation": 1
    }
  }, _vm._l(_vm.pages, function (page, index) {
    return _c('div', {
      key: 'pageNumber' + index
    }, [_c('sign-form-signature-page-list-sheet', {
      staticClass: "ml-1 mr-n1",
      staticStyle: {
        "margin": "3px 1px 3px 1px"
      },
      attrs: {
        "id": _vm.PAGE_LIST_ID + index,
        "index": index,
        "currentPageNumber": _vm.currentPageNumber,
        "document": _vm.document,
        "page": page
      },
      on: {
        "setCurrentPage": _vm.setCurrentPage
      }
    })], 1);
  }), 0)], 1) : _vm._e(), _c('v-col', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "cols": "12",
      "xs": 12 - 0 * _vm.isVerticalPageList,
      "sm": 12 - 2 * _vm.isVerticalPageList,
      "md": 7 - 1 * _vm.isVerticalPageList,
      "lg": 9 - 1 * _vm.isVerticalPageList
    }
  }, [_c('div', {
    style: "height: calc( 100% ".concat(_vm.$vuetify.breakpoint.smAndDown ? '- 70px' : '', ")")
  }, [_vm.isLoading ? _c('v-skeleton-loader', {
    staticClass: "ma-auto",
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "type": "image@4"
    }
  }) : _c('sign-form-editor-canvas', {
    key: 'pagecanvas' + _vm.currentPageNumber,
    ref: "detailCardEditor",
    attrs: {
      "sideBarElement": _vm.DocumentDetailSideBarElements.CLOSED,
      "isSignature": false,
      "isSigning": true,
      "isLoading": _vm.isLoading,
      "currentPageNumber": _vm.currentPageNumber,
      "pages": _vm.pages
    },
    on: {
      "setCurrentPage": _vm.setCurrentPage,
      "previousPage": _vm.previousPage,
      "nextPage": _vm.nextPage
    }
  })], 1), _c('div', {
    staticStyle: {
      "background-color": "#f5f5f5"
    }
  }, [_vm.$vuetify.breakpoint.smAndDown ? _c('v-sheet', {
    staticClass: "pa-1",
    attrs: {
      "rounded": "tr-lg tl-lg"
    }
  }, [_vm.highlightedToken ? _c('v-text-field', {
    ref: "textField",
    attrs: {
      "label": _vm.highlightedToken.title,
      "hint": _vm.highlightedToken.description,
      "persistent-hint": _vm.highlightedToken.description,
      "dense": "",
      "outlined": "",
      "append-icon": "mdi-close"
    },
    on: {
      "click:append": _vm.resetHighlightedToken
    },
    model: {
      value: _vm.highlightedToken.value,
      callback: function callback($$v) {
        _vm.$set(_vm.highlightedToken, "value", $$v);
      },
      expression: "highlightedToken.value"
    }
  }) : _c('v-text-field', {
    attrs: {
      "dense": "",
      "outlined": "",
      "disabled": ""
    }
  })], 1) : _vm._e()], 1)]), !_vm.$vuetify.breakpoint.smAndDown ? _c('v-col', {
    staticStyle: {
      "height": "100%",
      "background-color": "#f5f5f5"
    },
    attrs: {
      "cols": "0",
      "md": "5",
      "lg": "3"
    }
  }, [_c('v-row', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-sheet', {
    staticStyle: {
      "height": "100%",
      "width": "100%",
      "z-index": "2"
    },
    attrs: {
      "rounded": "tl-lg bl-lg",
      "elevation": 1
    }
  }, [_c('v-col', {
    staticStyle: {
      "height": "calc(100% - 70px)",
      "width": "100%",
      "overflow-y": "hidden"
    },
    attrs: {
      "cols": "12"
    }
  }, [_vm.isLoading ? _c('v-skeleton-loader', {
    staticClass: "mx-auto",
    attrs: {
      "type": "card-heading, list-item-two-line, list-item-two-line"
    }
  }) : _c('sign-form-editor-input-list', {
    attrs: {
      "signRequest": _vm.signRequest,
      "currentPageNumber": _vm.currentPageNumber
    },
    on: {
      "setCurrentPage": _vm.setCurrentPage
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "align": "end"
    }
  }, [_vm.isLoading ? _c('v-skeleton-loader', {
    attrs: {
      "type": "list-item, list-item"
    }
  }) : _c('sign-form-editor-controls', {
    attrs: {
      "pageCount": _vm.pages.length,
      "document": _vm.document,
      "isMobile": false
    },
    on: {
      "previousPage": _vm.previousPage,
      "nextPage": _vm.nextPage,
      "sign": function sign(signature) {
        return _vm.$emit('sign', signature);
      }
    }
  })], 1)], 1)], 1)], 1) : _vm._e()], 1), _vm.isHorizontalPageList ? _c('v-row', {
    style: "height: 100px; width: ".concat(_vm.clientWidth, "px; overflow-y: hidden;  overflow-x: auto; "),
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('v-spacer'), _vm._l(_vm.pages, function (page, index) {
    return _c('div', {
      key: 'pageNumber' + index
    }, [_c('sign-form-signature-page-list-sheet', {
      staticStyle: {
        "max-width": "100px",
        "max-height": "100px",
        "margin": "1px 4px 1px 4px"
      },
      attrs: {
        "index": index,
        "currentPageNumber": _vm.currentPageNumber,
        "document": _vm.document,
        "page": page
      },
      on: {
        "setCurrentPage": _vm.setCurrentPage
      }
    })], 1);
  }), _c('v-spacer')], 2)])], 1) : _vm._e(), _vm.$vuetify.breakpoint.smAndDown ? _c('sign-form-editor-controls', {
    attrs: {
      "document": _vm.document,
      "fab": true,
      "pageCount": _vm.pages.length,
      "isMobile": true
    },
    on: {
      "previousPage": _vm.previousPage,
      "nextPage": _vm.nextPage,
      "sign": function sign(signature) {
        return _vm.$emit('sign', signature);
      }
    }
  }) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }